// Константы из универсального  справочника
export const PARTNER_APPLICATION = 136;
export const CLIENT_APPLICATION = 137;
export const WEB_APPLICATION = 138;

export const INSTRUCTIONS = 215;
export const PVY_246 = 246;
export const OSAGO_247 = 247;
export const UUU_KASKO_248 = 248;
export const FAST_MONEY = 250;
export const CALCULATION = 454;
export const KASKO_GO_524 = 524;
export const INDEPENDENT_EXAMINATION_525 = 525;
export const PRE_INSURANCE_EXAMINATION_526 = 526;
export const TYPE_460 = 460;
export const TYPE_461 = 461;
export const TYPE_530 = 530;

export const INSURANCE_TYPE_OSAGO = 37;
export const INSURANCE_TYPE_KASKO = 38;

export const USER_STATUS_INVITED = 15;
export const USER_STATUS_ACTIVE = 16;
export const USER_STATUS_BLOCKED = 18;

export const INVOICE_FORMED = 307;
export const INVOICE_SENT = 308;
export const INVOICE_ACCEPTED = 309;
export const INVOICE_DISCARDED = 310;
export const INVOICE_PAID = 311;
export const INVOICE_CLOSED = 312;
export const INVOICE_DELETED = 466;
export const INVOICE_PAID_WAITING_MONEY = 491;
export const INVOICE_MONEY_RETURN = 541;
export const INVOICE_PAID_PROMO = 664;
export const MULTISPLIT_PAYMENT_ACTIVE = 736;
export const MULTISPLIT_PAYMENT_MONEY_BLOCKED = 737;

export const TYPE_OPERATION = {
  TIRE_SERVICE_COMPLEX_1_361: 361,
  TIRE_SERVICE_COMPLEX_2_244: 244,
  TIRE_SERVICE_COMPLEX_3_487: 487,
  TIRE_SERVICE_COMPLEX_4_REINFORCED_CORD_741: 741,
  TIRE_SERVICE_COMPLEX_5_OFF_ROAD_742: 742,
  WHEEL_BALANCING_245: 245,
  VALVE_INSTALLATION_362: 362,
  PUNCTURE_REPAIR_243: 243,
  VULCANIZATION_REPAIR_368: 368,
  STUDDING_363: 363,
  MUSHROOM_PATCH_REPAIR_360: 360,
  WHEEL_STRAIGHTENING_488: 488,
} as const;

// для справки:
// const services = [
//   { id: 361, name: "Комплекс Шиномонтажа №1" },
//   { id: 244, name: "Комплекс Шиномонтажа №2" },
//   { id: 487, name: "Комплекс Шиномонтажа №3" }
//   { id: 245, name: "Балансировка" },
//   { id: 362, name: "Установка ниппеля" },
//   { id: 243, name: "Ремонт прокола" },
//   { id: 368, name: "Ремонт прокола вулканизацией" },
//   { id: 363, name: "Дошиповка" },
//   { id: 360, name: "Ремонт прокола грибком" },
//   { id: 488, name: "Правка  диска" },
// ];
